import { CSSProperties } from 'react'
import styled from 'styled-components'

export const ChartAnnotation = ({
  text,
  style,
}: {
  text: string | JSX.Element
  style?: CSSProperties
}) => {
  return <ChartAnnotationRoot style={style}>{text}</ChartAnnotationRoot>
}

const ChartAnnotationRoot = styled.div`
  line-height: 1.4em;
  background-color: var(--yellow-main);
  color: var(--brandblue-main);
  /* transform: translateY(-100%); */
  padding: 4px 8px;
  display: inline-block;
  font-size: 15px;
  border-radius: 4px;

  padding: 15px;
  position: relative;
  /* &::before {
    position: absolute;
    top: 50%;
    left: 10px;
    transform: translateY(-50%);
    content: '';
    display: inline-block;
    width: 0;
    height: 0;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-top: 8px solid var(--text-color);
  } */
`
